import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { addTimeout, deactivateToaster, removeToaster } from './redux/actions';
import ToasterComponent from './toaster-component';

const mapStateToProps = (state: ApplicationState) => ({
  toasters: state.toasters,
  t: state.i18n.t
});

export default connect(mapStateToProps, { removeToaster, deactivateToaster, addTimeout })(
  ToasterComponent
);
